import { cn } from '@/lib/utils';

interface Tab {
  id: string;
  label: string;
  count?: number;
}

interface TabSwitcherProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tabId: string) => void;
}

export function TabSwitcher({ tabs, activeTab, onChange }: TabSwitcherProps) {
  return (
    <div className="bg-white border-b border-neutral-light px-4 py-2">
      <div className="flex gap-2">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={cn(
              'px-4 py-2 rounded-full text-sm font-medium transition-colors',
              activeTab === tab.id
                ? 'bg-primary text-white'
                : 'text-neutral-medium hover:bg-neutral-light/50'
            )}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span className="ms-1.5 opacity-75">({tab.count})</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
